export default "__VITE_ASSET__ChKlu9aw__"